import React from 'react';
import { motion } from 'framer-motion';
import { formatEventType } from '../utils/api';

const Hero = ({ invitation }) => {
  const { guest_name, max_pax, event_type } = invitation;

  // Create personalized greeting
  const getGreeting = () => {
    if (max_pax > 1) {
      return `Dear ${guest_name}`;
    }
    return `Dear ${guest_name}`;
  };

  const getPaxText = () => {
    if (max_pax === 1) {
      return '';
    } else if (max_pax === 2) {
      return ' & Guest';
    } else {
      return ` & ${max_pax - 1} Guests`;
    }
  };

  return (
    <section className="relative h-screen flex items-start justify-center overflow-hidden pt-20 md:pt-40">
      {/* Animated background */}
      <div className="absolute inset-0 bg-hero bg-cover bg-center -z-10">
        {/* <div className="absolute -top-1/2 -right-1/5 w-[800px] h-[800px] bg-sage/10 rounded-full blur-3xl animate-float" />
        <div className="absolute -bottom-1/3 -left-1/10 w-[600px] h-[600px] bg-terracotta/20 rounded-full blur-3xl animate-float"
              style={{ animationDuration: '15s', animationDirection: 'reverse' }} /> */}
      </div>

      {/* Personalized greeting */}
      {/* <motion.div
        className="w-screen h-screen absolute backdrop-blur-lg z-20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        <div className="p-24 flex h-full w-full flex-col justify-between">
          <div className="title text-white">
            <p>Wedding of</p>
            <h1 className='text-6xl md:text-8xl lg:text-9xl font-display my-8 -tracking-wider'>Caleb & Alyssa</h1>
            <p>2026.04.11</p>
          </div>

          <div className="text-white">
            <p className="text-2xl md:text-3xl font-body ">
            Dear,
            </p>
            <h1 className='text-6xl md:text-8xl lg:text-9xl font-display mb-8 -tracking-wider'>{guest_name}</h1>
            <button className='block w-full px-8 py-4 bg-white text-charcoal hover:bg-sage-light hover:text-white rounded-md transition duration-300'>Open Invitation</button>
          </div>
        </div>
      </motion.div> */}

      <div className="relative z-10 text-center max-w-4xl p-8 rounded-md">

        {/* Event Type */}
        <motion.p
          className="text-xl md:text-sm tracking-[0.3em] uppercase text-white mb-8 font-body font-bold"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          We’re getting married
        </motion.p>

        <motion.h1
          className="text-6xl md:text-8xl lg:text-9xl font-display italic text-white mb-8 -tracking-wider"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, delay: 1 }}
        >
          Caleb & Alyssa
        </motion.h1>

        <motion.div
          className="h-px w-0 bg-white shadow-[0_0_10px_rgba(201,169,97,0.3)] mx-auto mb-8"
          initial={{ width: 0 }}
          animate={{ width: '120px' }}
          transition={{ duration: 1, delay: 1.5 }}
        />

        <motion.p
          className="text-lg md:text-xl font-body text-white mb-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.8 }}
        >
          Saturday, 11 April 2026
        </motion.p>
      </div>

      <motion.div
        className="absolute text-white bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4 text-sage-dark text-xs tracking-[0.2em] uppercase"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 2.5 }}
      >
        <span>Scroll to explore</span>
        <div className="w-[4px] h-10 bg-gradient-to-b from-white to-transparent animate-scroll-pulse" />
      </motion.div>
    </section>
  );
};

export default Hero;
